<template>
  <form @submit.prevent="Submit()" class="t-commentForm">
    <h2 v-if="answer === null">{{ commentsText.addComment }}</h2>
    <h2 v-else>{{ commentsText.answerTitle }} {{ answer.author }} <span @click.prevent="ClearAnswer()"></span></h2>
    <div class="t-input">
      <textarea v-model="text"></textarea>
    </div>
    <button class="t-btn" :class="{_disabled: text === ''}"><span>{{ commentsText.addComment }}</span></button>
  </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        data(){
            return {
                text: ''
            }
        },
        props: ['answer'],
        computed: {
            ...mapGetters('staticText', ['commentsText']),
            ...mapGetters('coursesList', ['course'])
        },
        methods: {
            ...mapActions('coursesList', ['LoadComments']),
            ...mapActions('msg', ['showMsg']),
            ClearAnswer(){
                this.$emit('ClearAnswer');
            },
            Submit(){
                let fd = new FormData();
                fd.append('text', this.text);

                let url = this.answer === null ? 'courses/' + this.course.id + '/comments' : 'courses/' + this.course.id + '/comments/' + this.answer.id;

                this.$http.post(url, fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.text = '';
                            this.showMsg(this.commentsText.msg);
                            this.LoadComments({id: this.course.id, page: this.$route.query.page});
                        } else{
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            }
        }
    }
</script>

<style lang="sass">
.t-commentForm
  h2
    margin-bottom: 24px
    span
      width: 20px
      height: 20px
      position: relative
      cursor: pointer
      display: inline-block
      margin-left: 12px
      &:before, &:after
        content: ''
        position: absolute
        top: 50%
        left: 0
        width: 100%
        height: 2px
        border-radius: 1px
        background: $grey
        margin-top: -1px
      &:before
        transform: rotate(45deg)
      &:after
        transform: rotate(-45deg)
  textarea
    height: 120px
</style>


// WEBPACK FOOTER //
// src/vue_components/Comments/Form.vue